import React from 'react';
import TextBlockConfig from './blocks/TextBlockConfig';
import HeroSliderConfig from './blocks/HeroSliderConfig';
import VideoBlockConfig from './blocks/VideoBlockConfig';
import CarouselBlockConfig from './blocks/CarouselBlockConfig';
import GalleryGridConfig from './blocks/GalleryGridConfig';
import StatsBlockConfig from './blocks/StatsBlockConfig';
import DividerConfig from './blocks/DividerConfig';
import PullQuoteConfig from './blocks/PullQuoteConfig';
import ImageBlockConfig from './blocks/ImageBlockConfig';
import ImageDuoConfig from './blocks/ImageDuoConfig';
import ProductsBlockConfig from './blocks/ProductsBlockConfig';
import SeparatorConfig from './blocks/SeparatorConfig';
import RelatedPostsConfig from './blocks/RelatedPostsConfig';

const CONFIG_MAP = {
  text: TextBlockConfig,
  hero_slider: HeroSliderConfig,
  image: ImageBlockConfig,
  image_duo: ImageDuoConfig,
  video: VideoBlockConfig,
  carousel: CarouselBlockConfig,
  gallery: GalleryGridConfig,
  stats: StatsBlockConfig,
  products: ProductsBlockConfig,
  divider: DividerConfig,
  separator: SeparatorConfig,
  pullquote: PullQuoteConfig,
  related_posts: RelatedPostsConfig,
};

export default function BlockConfigPanel({ block, onUpdate, onDeselect }) {
  if (!block) {
    return (
      <div className="adminblog-block-config">
        <h4>Block Settings</h4>
        <p style={{ fontSize: 13, color: '#999' }}>Select a block to edit its settings.</p>
      </div>
    );
  }

  const ConfigComponent = CONFIG_MAP[block.type];
  if (!ConfigComponent) return null;

  const handleDataChange = (newData) => {
    onUpdate({ ...block, data: newData });
  };

  return (
    <div className="adminblog-block-config">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h4 style={{ margin: 0, border: 'none', paddingBottom: 0 }}>
          Editando: {block.type.replace('_', ' ')}
        </h4>
        {onDeselect && (
          <button
            onClick={onDeselect}
            style={{
              background: 'none',
              border: '1px solid #ddd',
              borderRadius: 4,
              padding: '4px 10px',
              fontSize: 12,
              cursor: 'pointer',
              color: '#666',
            }}
          >
            ✕ Close
          </button>
        )}
      </div>
      <div style={{ marginTop: 16 }}>
        <ConfigComponent data={block.data} onChange={handleDataChange} />
      </div>
    </div>
  );
}
